export enum LogBatchStatusEnum
{
    Processing = 1,
    Success = 2,
    Warning = 3,
    Error = 4
}